// extracted by mini-css-extract-plugin
module.exports = {"button":"SortBy_button__3aNUa","active":"SortBy_active__1qLYo","label":"SortBy_label__3Sgq5"};